import { TicketLineDTO, SoldProductType, Res, Permission } from 'core/api';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { CustomerDisplay } from 'pos/services';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		setTicketLineDiscountPercentage: (line: TicketLineDTO, discountPercentage: number) => Promise<Result>
	}
}

Command.register('setTicketLineDiscountPercentage', Preconditions.ensure(Permission.Ticket_SetTicketLinePercentageDiscount), async (line: TicketLineDTO, discountPercentage: number): Promise<Result> => {
	if (line.Type === SoldProductType.MenuItem) {
		await Message.show(Res.Msg.MSG_CANNOT_ESTABLISH_DISCOUNTS_IN_MENU_ITEM_LINE());
		return Result.error();
	}

	await SalesStore.setLineDiscountPercentage(line, discountPercentage);
	await CustomerDisplay.displayLineDiscountPercentage(SalesStore.getTicket(), SalesStore.getLineById(line.Id));
	return Result.ok();
});